import {
  HTTPError,
  captureException,
  captureExceptionWithInfo,
} from '@mondough/error-handling'

export const captureSharedTabsException = (
  error: Error | HTTPError | unknown,
  errorInfo?: React.ErrorInfo | Record<string, unknown>,
  statusToIgnore: number[] = [401, 404],
) => {
  if (error instanceof HTTPError && statusToIgnore.includes(error.status)) {
    return
  }
  if (errorInfo) {
    captureExceptionWithInfo(error as Error, errorInfo)
  } else {
    captureException(error as Error)
  }

  return
}
